import emailjs from "emailjs-com"

export const sendMentorMail = (message) => {
    emailjs.send("service_nrs8ksv","template_8dj0u88",{...message})
}

export const sendMenteeMail = (message) => {
    emailjs.send("service_nrs8ksv","template_xu3cims",{...message})
}